/*
 * Copyright (c) 2021 biocrates life sciences ag, All rights reserved.
 */

import {ActionType, createAction} from "typesafe-actions"
import Error from "../../../@biocrates-common-repo/core/models/error"

export const showErrorReport = createAction("SHOW_ERROR_REPORT")<Error>()
export const hideErrorReport = createAction("HIDE_ERROR_REPORT")<void>()

export type ErrorReportActions = ActionType<
    typeof showErrorReport | typeof hideErrorReport
>
